import Image from 'next/image';
import {
  useParams,
  usePathname,
  useRouter,
  useSearchParams
} from 'next/navigation';

import { useUIContext } from '@/components/context/uiContext/ManagedUiContext';
import { DEVICE_SURFACE, staticMediaStoreBaseURL } from '@/config/common';
import { captureGTMEventWhatsappClick } from '@/lib/gtm';
import {
  HEBA_PAGE_ROUTE,
  getPlanEventWithHebaURL
} from '@/services/planEventWithHeba.service';

const WhatsappSupportIcon = () => {
  const { surface } = useUIContext();
  const isMobile = surface === DEVICE_SURFACE.MOBILE;

  const router = useRouter();
  const pathname = usePathname();
  const params = useParams();
  const searchParams = useSearchParams();

  const openWhatsapp = async () => {
    captureGTMEventWhatsappClick();
    router.push(
      getPlanEventWithHebaURL({
        pageRoute: HEBA_PAGE_ROUTE.WHATSAPP,
        params,
        pathname,
        searchParams
      })
    );
  };

  return (
    <div
      className='flex items-center cursor-pointer relative mx-3 md:ml-6 md:mr-4'
      onClick={openWhatsapp}
    >
      <Image
        src={`${staticMediaStoreBaseURL}/icons/whatsapp-green.svg`}
        height={isMobile ? 24 : 33}
        width={isMobile ? 24 : 33}
        alt='Whatsapp'
      />
    </div>
  );
};

export default WhatsappSupportIcon;
